

export const formatDateForDisplay = (date: Date): string => {
  return date.toLocaleDateString('en-US', {
    year: '2-digit',
    month: 'short',
    day: '2-digit',
  });
};

export function getWeekBounds(date = new Date(), weekStartsOn: 0|1|2|3|4|5|6 = 1, includeNextWeek = false) {
  const d = new Date(date);
  const day = d.getDay() + (includeNextWeek ? 1 : 0); // 0=Sun..6=Sat
  const diffToStart = ( (day - weekStartsOn) + 7 ) % 7;
  const start = new Date(d);
  start.setDate(d.getDate() - diffToStart);
  start.setHours(0, 0, 0, 0);

  const end = new Date(start);
  end.setDate(start.getDate() + 6);
  end.setHours(23, 59, 59, 999);

  return { first: start, last: end };
}

export function getMonthBounds(date = new Date(), includeNextMonth = false) {
  const y = date.getFullYear();
  const m = date.getMonth() + (includeNextMonth ? 1 : 0); // 0–11
  const first = new Date(y, m, 1, 0, 0, 0, 0);
  const last = new Date(y, m + 1, 0, 23, 59, 59, 999);
  return { first, last };
}

export function getQuarterBounds(date = new Date()) {
  const y = date.getFullYear();
  const m = date.getMonth(); // 0..11
  const qStartMonth = Math.floor(m / 3) * 3; // 0,3,6,9
  const first = new Date(y, qStartMonth, 1, 0, 0, 0, 0);
  const last = new Date(y, qStartMonth + 3, 0, 23, 59, 59, 999); // day 0 of next quarter
  return { first, last };
}

export function getYearBounds(date = new Date()) {
  const y = date.getFullYear();
  const first = new Date(y, 0, 1, 0, 0, 0, 0);
  const last = new Date(y, 11, 31, 23, 59, 59, 999);
  return { first, last };
}


export const onPresetDateSelect = (preset: string) => {
  switch (preset) {
    case 'current_week':
      return { startDate: getWeekBounds(new Date()).first, endDate: getWeekBounds(new Date()).last };
    case 'current_month':
      return { startDate: getMonthBounds(new Date()).first, endDate: getMonthBounds(new Date()).last };
    case 'current_quarter':
      return { startDate: getQuarterBounds(new Date()).first, endDate: getQuarterBounds(new Date()).last };
    case 'current_year':
      return { startDate: getYearBounds(new Date()).first, endDate: getYearBounds(new Date()).last };
    case 'next_week':
      return { startDate: getWeekBounds(new Date(), 1, true).first, endDate: getWeekBounds(new Date(), 1, true).last };
    case 'next_month':
      return { startDate: getMonthBounds(new Date(), true).first, endDate: getMonthBounds(new Date(), true).last };
    default:
      return { startDate: getMonthBounds(new Date()).first, endDate: getMonthBounds(new Date()).last };
  }
};